<template>
  <div class="back-to-top" >
    <span @click="scrollToTop()">Back to top</span>
  </div>
</template>

<script>

export default {
  name: "BackToTop",
  data() {
    return {};
  },
  methods: {
    scrollToTop() {
       $('html, body').animate({scrollTop:0}, 'slow');
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/BackToTop.vue